import tokenManage from '@/common/tokenManage'

// import { accessor } from '@/store/accessor'
// import { goLogin } from '@/views/sign/login/utils'
import { TOKEN_KEY } from '../const'
import { service } from './service'
import type { ApiConfig, ApiResult, AxiosRequestConfig, AxiosResponse } from './types'
import { cleanFalsyValues } from './util'

export * from './types'

/**
 * 统一请求方法
 * @param config axios配置参数
 * @param custom 自定义配置参数
 */
export default async function request<RESD, T> (config?: AxiosRequestConfig, custom?: ApiConfig) {
  const token = custom?.token ?? true
  const cleanFalsy = custom?.cleanFalsy ?? true

  const data: any = { ...config?.data }

  if (token) {
    data[TOKEN_KEY] = tokenManage.sid
  }

  if (custom?.cleanFalsy ?? true) {
    cleanFalsyValues(data, cleanFalsy)
  }

  config = { ...config, data }

  const res = await service.request<T, AxiosResponse<ApiResult & RESD>>(config)

  const { error_code } = res.data

  // 刷新sid有效期
  if (error_code === 0 && token) {
    tokenManage.update()
  } else if (error_code === 8684) {
    tokenManage.sid = ''
    // accessor.sign.logout()
    // goLogin()
  }
  return res
}
